export const WILDCARD_TOOLTIP_TEXT = 'Wildcards are single character '
    + 'placeholders that can be used to match a number of '
    + 'characters within a string. ironSource supports three standard wildcards:'
    + ' asterisk (*), comma (,) and question mark (?).';

export const PROPERTY_IDS = {
    customSegment: 1,
    age: 2,
    sdkVersion: 5,
    userCreationDate: 6,
    osVersion: 10,
    levelId: 11,
    totalInAppPurchases: 12,
    country: 14,
    apiLevel: 15,
    idfa: 16,
    coppa: 17,
    customProperty: 100
};

export const FIELD_TYPES = {
    Integer: 'Integer',
    String: 'String',
    Boolean: 'Boolean',
    Version: 'Version',
    Float: 'Float',
    Enum: 'Enum',
    Date: 'Date',
    Array: 'Array'
};

export const segmentNameMaxLength = 32;

export const customNameMaxLength = 32;
